<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faMoneyBills,faGift,faDotCircle } from '@fortawesome/free-solid-svg-icons';
    import Time from "svelte-time";

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false
  

    let isList = false
    let messageList = []


    async function gethistory() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/messagelist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            messageList = json.payload
            isList = true
		} else {
            throw new Error(json);
		}
    }
    async function readmessage(ids) {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/readmessage", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({_id:ids})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            gethistory()
		} else {
            throw new Error(json);
		}
    }
    $: {
        gethistory()
    }


</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    
   
    <div class="col-12 text-center mt-3" ><h4 style="background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;color:gold;">ข้อความ</h4></div>
    
    <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center text-white">
                {#if isList}

                {#each messageList as gms}
                <div class=" shadow rounded ps-3 pt-2 pe-3 pb-1  mb-2" style="background: linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(86, 80, 80) 50%, rgb(131, 120, 120) 51%, rgb(54, 50, 50) 71%, rgb(0, 0, 0) 100%); box-shadow: rgb(0, 0, 0) 5px 5px 10px !important; line-height: 30px; border-radius: 5px; padding: 2px 7px; color: gold;">
                    
                    <div class="row" >
                        <div class="col-10 text-start text-info">
                            <span>{gms.title}</span> {#if gms.read==0}<span style="cursor: pointer;" on:click={() => readmessage(gms._id)}><Fa icon={faDotCircle} class="text-warning"/></span>{/if}
                        </div>
                        
                        <div class="col-12 text-start">
                            <p class="text-white mb-1" style="line-height: normal;">{gms.message}</p>
                            <small class="pt-0 text-white-50">ส่งเมื่อ : <Time timestamp="{gms.gentime*1000}" format="DD/MM/YYYY HH:mm:ss" /></small>
                        </div>
                    </div>
                </div>
                {/each}
 
                {/if}
            </div>
        </div>
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-messages">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title">ข้อความ</h4></div>
        
        <div class="col-12" style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-2" style="">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
            </div>
            {/if}
            {#if !loading}
            <div class="card mt-2 bg-black">
                <div class="card-body text-center text-white">
                    {#if isList}
    
                    {#each messageList as gms}
                    <div class=" shadow rounded ps-3 pt-2 pe-3 pb-1  mb-2 mini-blog" >
                        <div class="row" >
                            <div class="col-10 text-start text-info">
                                <span>{gms.title}</span> {#if gms.read==0}<span style="cursor: pointer;" on:click={() => readmessage(gms._id)}><Fa icon={faDotCircle} class="text-warning"/></span>{/if}
                            </div>
                            
                            <div class="col-12 text-start">
                                <p class="text-white mb-1" style="line-height: normal;">{gms.message}</p>
                                <small class="pt-0 text-white-50">ส่งเมื่อ : <Time timestamp="{gms.gentime*1000}" format="DD/MM/YYYY HH:mm:ss" /></small>
                            </div>
                        </div>
                    </div>
                    {/each}
     
                    {/if}
                </div>
            </div>
            {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">

</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.8rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
</style>